import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";
import * as util from "./util";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";
import {CustomerFilter} from "@/model/filters";


export async function getCustomers(filter: CustomerFilter, isExport: boolean = false): Promise<any> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };
  const filterCount = util.countPredicate([
    filter.q, filter.subscriptionPlanId, filter.areaId, filter.dateStart, filter.dateEnd, 
    filter.customerType, filter.coType, filter.idType, filter.dateExpStart, filter.dateExpEnd
  ]);
  if (filter.q && filterCount === 1) {
    if(!isExport)
    body.filters.push(
      { field: "isDeleted", operator: "eq", value: filter.isDeleted, logic: "and" }
    );
    body.filters[0].filters = [
      { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "email", operator: "contains", value: filter.q, logic: "or" },
      { field: "phoneNumber", operator: "contains", value: filter.q, logic: "or" }
    ];
  } else {
    if(filter.isDeleted) {
      body.filters.push(
        { field: "isDeleted", operator: "eq", value: filter.isDeleted, logic: "and" }
    );
    
    }
    else{
    if (filter.areaId) {
      body.filters.push(
        { field: "saleAreaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }
    if (filter.subscriptionPlanId && filter.subscriptionPlanId.length != 0) {
      if(filter.subscriptionPlanId.length == 1)
        body.filters.push(
          { field: "subPlanId", operator: "eq", value: filter.subscriptionPlanId[0], logic: "and" }
        );
      else {
          const filters : any[] = [];
          filter.subscriptionPlanId.forEach((planId, i) => {
            filters.push({ field: "subPlanId", operator: "eq", value: planId, logic: i==filter.subscriptionPlanId.length-1 ? "and":"or"});
          })
          body.filters.unshift({field: "all", operator: "eq", value: "", logic: "and"});
          body.filters[0].filters = filters;
        }
    }

    if (filter.dateStart) {
      body.filters.push(
        { field: "cusSubStartDate", operator: "gte", value: filter.dateStart, logic: "and" }
      );
    }

    if (filter.dateEnd) {
      body.filters.push(
        { field: "cusSubStartDate", operator: "lte", value: filter.dateEnd, logic: "and" }
      );
    }

    if (filter.dateExpStart) {
      body.filters.push(
        { field: "cusSubEndDate", operator: "gte", value: filter.dateExpStart, logic: "and" }
      );
    }

    if (filter.dateExpEnd) {
      body.filters.push(
        { field: "cusSubEndDate", operator: "lte", value: filter.dateExpEnd, logic: "and" }
      );
    }

    if (filter.customerType) {
      body.filters.push(
        { field: "customerType", operator: "eq", value: filter.customerType, logic: "and" }
      );
    }

    if (filter.idType) {
      body.filters.push(
        { field: "idType", operator: "eq", value: filter.idType, logic: "and" }
      );
    }

    if (filter.coType) {
      body.filters.push(
        { field: "corporations", operator: "eq", value: filter.coType, logic: "and" }
      );
    }
    if(!isExport)
    body.filters.push(
      { field: "isDeleted", operator: "eq", value: filter.isDeleted, logic: "and" }
    );
    
    if (filter.q) {
      body.filters.unshift({field: "all", operator: "eq", value: "", logic: "and"})
      body.filters[0].filters = [
        { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
        { field: "email", operator: "contains", value: filter.q, logic: "or" },
        { field: "phoneNumber", operator: "contains", value: filter.q, logic: "or" }
      ];
    }}
  }

  if(!isExport)
  return (await axiosInstance.post<DataSourceResult<any>>(`/Customer/GetCustomerList/${filter.subscriptionPlanStatus || "all"}`, body, { headers })).data;
  else
  return  (await axiosInstance.post<DataSourceResult<any>>(`/Customer/GetCustomerList/${filter.subscriptionPlanStatus || "all"}/ExportExcel`, body, { headers })).data;
}


export async function getDetails(id: number) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get(`/Customer/GetCustomerDetail/${id}`, { headers })).data;
}


export async function newCustomer(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Customer/AddNewCustomer", data, { headers })).data;
}


export async function updateCustomer(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Customer/UpdateCustomer", data, { headers })).data;
}


export async function deleteCustomer(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Customer/DeleteCustomer", null, { headers, params })).data;
}


export async function getDocumentTypes(): Promise<any[]> {
  const headers = userService.getAuthHeaders();
  const params = { page: 1, pageSize: 100 };

  return (await axiosInstance.get("/DocumentType/GetDocumentTypeList", { headers, params })).data.data;
}


export async function newSubscription(customerId: number, subscriptionPlanId: number, 
  numberOfConcurrentMeetings: number, startTime: string) {
  const headers = userService.getAuthHeaders();
  const body = { customerId, subscriptionPlanId, startTime, numberOfConcurrentMeetings };

  return (await axiosInstance.post("/CustomerSubscription/AddNewCustomerSubscription", body, { headers })).data;
}


export async function renewSubscription(customerSubscriptionId: number, numberOfConcurrentMeetings: number) {
  const headers = userService.getAuthHeaders();
  const body = { customerSubscriptionId, numberOfConcurrentMeetings };

  return (await axiosInstance.post("/CustomerSubscription/RenewService", body, { headers })).data;
}


export async function upgradeSubscription(data) {
  const headers = userService.getAuthHeaders();
  const params = _.pick(data, ["dateStartToUpgrade", "upgradeOption", "numOfMonth"]);
  const body = _.pick(data, ["customerSubscriptionId", "newSubPlanId", "numberOfConcurrentMeetings"]);

  return (await axiosInstance.post("/CustomerSubscription/UpgradeService", body, { headers, params })).data;
}

export async function sendSubscriptionReminderEmail(customerSubscriptionId: number) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/CustomerSubscription/SendMailRenewService/" + customerSubscriptionId, { headers })).data;
}

export async function cancelService(customerSubscriptionId: number) {
  const headers = userService.getAuthHeaders();
  const params = {customerId: customerSubscriptionId}
  return (await axiosInstance.post("CustomerSubscription/CancelSubscription", null, { headers, params })).data;
}
